import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  taxIdInformation: {
    description: 'description to clarify tax identifier modal',
    defaultMessage:
      'ShipStation only offers B2B services. Per government guidelines, local taxes will be applied to those who do not provide a {taxIdName} number. To avoid this please enter your {taxIdName} information. Once this is set, it can not be changed. <a>Learn more about {taxIdName} Requirements.</a>',
    id: 'rr2ae8',
  },
});
